/* src/app/agent-builder/agent-builder-list/agent-builder-list.component.scss */
:host {
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
  height: 100%;
  position: relative;
}
nz-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
nz-card ::ng-deep .ant-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.full-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.full-table .ant-table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.full-table .ant-table-body {
  flex: 1 !important;
  overflow-y: auto !important;
}
nz-table {
  width: 100%;
}
nz-table ::ng-deep .ant-table {
  font-size: 13px;
}
nz-table ::ng-deep .ant-table-thead > tr > th {
  background-color: var(--tem-surface-2);
}
div[style*="overflow-x: auto"] {
  margin: 16px 0;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
nz-empty {
  display: block;
  padding: 48px 0;
}
/*# sourceMappingURL=agent-builder-list.component.css.map */
